import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r6: FaireReviewEntity = {
  token: "review_r6",
  type: "review",
  brandName: "ROEN",
  reviewerName: "David W.",
  reviewerLocation: "Seattle, WA",
  stars: 4,
  reviewText:
    "Solid brand to carry. The margin is good and the product quality speaks for itself. My only wish is for smaller case packs.",
  reviewDate: "Nov 15, 2025",
  reviewType: "brand",
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
    "https://cdn.prerelease.faire.dev/fastly/56884e66685193058ffed10b4132877eba11d2a0013a35e2fa68ec6fad9c8ed6.webp",
  ],
  productImageUrl:
    "https://images.unsplash.com/photo-1603905179682-74a694e26d52?w=80&h=80&fit=crop",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
